import React from "react";
import { createRoot } from "react-dom/client"; // QUITAMOS hydrateRoot
import AppRouter from "./routes/AppRouter";
import "./index.css";
import { store } from "./store";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { HelmetProvider } from "react-helmet-async";
import "./assets/css/swiper_preload.css";

// Definimos la estructura de la App
const App = () => (
    <GoogleOAuthProvider clientId="383088837702-krlquqek9sronsemmle6lov3lcvaeguh.apps.googleusercontent.com">
        <Provider store={store}>
            <HelmetProvider>
                <AppRouter />
            </HelmetProvider>
        </Provider>
    </GoogleOAuthProvider>
);

// Obtenemos el elemento root
const container = document.getElementById("root") as HTMLElement;

// --- AGREGA ESTO AQUÍ (BLOQUEO GLOBAL) ---
// Esto aplica la clase y el atributo al <body> entero del navegador.
// Es mejor que ponérselo al container, porque así cubre también Modales y Portals.
document.body.classList.add("notranslate");
document.body.setAttribute("translate", "no");
// --- FIN DEL BLOQUEO GLOBAL ---

// Renderizado estándar de React 18 (SPA pura)
// Ya no necesitamos verificar childNodes ni dominios porque todo se genera en el cliente.
const root = createRoot(container);
root.render(<App />);
